/* esm.sh - react-remove-scroll@2.7.2 */
export * from "/*react-remove-scroll@2.7.2/esnext/react-remove-scroll.mjs";
